<template lang="pug">
.round-glow
  svg(xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 222 233")
    defs
      filter(x="-18.8%" y="-18.8%" width="137.5%" height="137.5%" filterUnits="objectBoundingBox" id="a")
        feGaussianBlur(stdDeviation="10" in="SourceGraphic")
      filter(x="-20.8%" y="-20.8%" width="137.2%" height="137.2%" filterUnits="objectBoundingBox" id="b")
        feOffset(dx="7" dy="7" in="SourceAlpha" result="shadowOffsetOuter1")
        feGaussianBlur(stdDeviation="5" in="shadowOffsetOuter1" result="shadowBlurOuter1")
        feColorMatrix(values="0 0 0 0 0.0862745098 0 0 0 0 0.545098039 0 0 0 0 1 0 0 0 0.158817745 0" in="shadowBlurOuter1" result="shadowMatrixOuter1")
        feOffset(dx="-5" dy="-5" in="SourceAlpha" result="shadowOffsetOuter2")
        feGaussianBlur(stdDeviation="10" in="shadowOffsetOuter2" result="shadowBlurOuter2")
        feColorMatrix(values="0 0 0 0 0.264691311 0 0 0 0 0.733418463 0 0 0 0 1 0 0 0 0.126775568 0" in="shadowBlurOuter2" result="shadowMatrixOuter2")
        feMerge
          feMergeNode(in="shadowMatrixOuter1")
          feMergeNode(in="shadowMatrixOuter2")
          
      filter(x="-17.2%" y="-17.2%" width="130%" height="130%" filterUnits="objectBoundingBox" id="d")
        feGaussianBlur(stdDeviation="3.5" in="SourceAlpha" result="shadowBlurInner1")
        feOffset(dx="5" dy="5" in="shadowBlurInner1" result="shadowOffsetInner1")
        feComposite(in="shadowOffsetInner1" in2="SourceAlpha" operator="arithmetic" k2="-1" k3="1" result="shadowInnerInner1")
        feColorMatrix(values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" in="shadowInnerInner1")
      circle(id="c" cx="90" cy="90" r="90")
    g(transform="translate(25 25)" fill="none" fill-rule="evenodd")
      circle(fill="#168BFF" opacity=".5" filter="url(#a)" cx="90" cy="103" r="80")
        use(fill="#000" filter="url(#b)" xlink:href="#c")
        //use(fill="#F9F9F9" xlink:href="#c")
        use(fill="#000" filter="url(#d)" xlink:href="#c")

  
</template>
<script>
export default {
  name: 'RoundGlow',
  props: {},
  data() {
    return {}
  },
  computed: {},
  methods: {},
  mounted() {},
  destroy() {},
}
</script>

<style scoped lang="sass">
@import "src/styles/common.sass"
.round-glow
  line-height: 0
  width: 100%
  height: 100%
  transform-origin: center
  animation: rotate linear infinite 2s
  svg
    width: 100%
    height: 100%
@keyframes rotate
  0%
    transform: rotateZ(0)
  100%
    transform: rotateZ(360deg)
</style>
